export const cropText = (text = '', maxLength = 20, postfix = '...') => {
    if (!text) {
        return '';
    }

    if (text.length <= maxLength) {
        return text;
    }

    const croppedText = text.substring(0, maxLength - postfix.length);
    return `${croppedText}${postfix}`
}

/**
 * Decode ROT13 encoded string
 * @param {string} str
 * @returns {string}
 */
export function decodeRot13(str) {
    return str.replace(/[a-zA-Z]/g, (char) => {
        const start = char <= 'Z' ? 65 : 97;
        return String.fromCharCode(((char.charCodeAt(0) - start + 13) % 26) + start);
    });
}

/**
 * Encode string to ROT13
 * ROT13 is symmetric, so encoding and decoding use the same function
 * @param {string} str
 * @returns {string}
 */
export function encodeRot13(str) {
    return decodeRot13(str);
}
